import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  root: {
    position: 'relative',
    display: 'inline-block',
    marginRight: 10
  },
  center: {
    display: 'flex',
    justifyContent: 'center'
  }
})

export {
  useStyles
}
